import { useState, useEffect } from 'react';
import { useGetAllQuery, useDeleteMutation } from '../../api';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import { Header } from '../Header/Header';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { useAuth0 } from '@auth0/auth0-react'

const columns = [
  { field: 'id', headerName: 'ID', width: 10 },
  { 
    field: 'text',
    headerName: 'Text',
    width: 500
  },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: () => (
      <Button
        variant="contained"
        color="warning"
        size="small"
        style={{ marginLeft: 16 }}
      >
        Delete
      </Button>            
    )
  },
  {
    field: 'edit',
    headerName: 'Edit',
    width: 100,
    renderCell: () => (
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ marginLeft: 16 }}        
      >
        Edit
      </Button>            
    )
  }  
];

export const List = () => {
  const [ errors, setErrors ] = useState()

  const [ accessToken, setAccessToken ] = useState('')
  
  const { getAccessTokenSilently } = useAuth0()
  
  const navigate = useNavigate()

  useEffect(() => {
    const getAccessToken = async () => {
      try {
        const token = await getAccessTokenSilently()
	setAccessToken(token)
      } catch (e) {
        console.log(e)
      }
    }
    getAccessToken()
  }, [])  
  
  /* eslint-disable no-restricted-globals */
  const [ deleteItem, { isLoading: isDeleting, isError: isDeleteError }] = useDeleteMutation(accessToken)
  
  const handleDelete = (params) => {
    if (params.field === 'delete') {
      const confirmed = confirm('Are you sure?')
      if (confirmed) {
        deleteItem(params.row.id)
          .unwrap()
          .then((data) => {
            navigate('/list')
          }).catch((err) => {
            console.log(err)
            setErrors('Unable to delete')
          })
      }
    }
    else if (params.field === 'edit') {
      const key = `${params.row.text}:${params.row.id}`
      navigate(`/${params.row.id}/${encodeURIComponent(params.row.text)}`)
    }
  }


  
  const { data,
	  isLoading,
	  isFetching,
	  isError,
	  isUninitialized
	} = useGetAllQuery(accessToken);
  if (isLoading || isFetching || isUninitialized || isError) {
    return (<LinearProgress />)
  }
  return (
    <>
      <Header />
      {
        isDeleteError && <Alert onClose={() => {}} severity="error"> Error while deleting </Alert>
      }
      <Fab
        onClick={() => navigate('/create')}
        sx={{position: 'absolute', bottom: 150, right: 8}}
        size="large" color="primary" aria-label="add">
        <AddIcon />
      </Fab>
      <Box sx={{ height: 700, width: '100%' }}>
        <DataGrid
          rows={data.data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5]}
          disableSelectionOnClick
          onCellClick={handleDelete}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>        
    </>  
  )
}
